export const subject_lang={
  EN:{
    title:"Requesting Data",
    sub_id:"subject id",
    subject_text:"subject",
    delete_title:"Are you sure to delete this data?",
    edit_subject:"Edit Subject Data",
    create_subject:"Add Subject",
    saved:"Data was saved",
    deleted:"Data was deleted"
  },
  TH:{
    title:"ข้อมูลร้องเรียน",
    sub_id:"รหัสหัวข้อการร้องเรียน",
    subject_text:"หัวข้อการร้องเรียน",
    edit:"แก้ไข",
    delete:"ลบ",
    cancel:"ยกเลืก",
    delete_title:"คุณต้องการลบข้อมูลนี้ใช่หรือไม่?",
    delete_warning:"ข้อมูลลบแล้วไม่สามารถยอนกลับได้!!",
    edit_subject:"แก้ไขข้อมูลหัวข้อการร้องเรียน",
    create_subject:"เพิ่มหัวข้อการร้องเรียน",
    "Add subject":"เพิ่มหัวข้อการร้องเรียน",
    "back to subject":"กลับมาหน้าแสดงข้อมูลการร้องเรียน",
    save:"บันทึก",
    "subject is require":"คุณต้องกรอกหัวข้อการร้องเรียนเพื่อบันทึกข้อมูล",
    saved:"ข้อมูลถูกบันทึกกเรียบร้อยแล้ว",
    deleted:"ข้อมูลถูกลบเรียบร้อยแล้ว",

  }
}
